export function createFormdata(obj) {
    let data = new FormData();

    for (let key in obj) {
    	console.log(key, obj[key])
        if (obj.hasOwnProperty(key)) {
            data.append(key, obj[key])
        }
    }

    return data;
}